module.exports = __webpack_public_path__ + "img/icons-soccer.affdd45e.svg";